import EcomBanner from './EcomBanner'
import EcomRetail from './EcomRetail'
import { lazy, Suspense } from 'react'

const EcommerceBuild = lazy(() => import("./EcommerceBuild"));
const EcomPlatfrom = lazy(() => import("./EcomPlatfrom"));
const EcomCollaborate = lazy(() => import("./EcomCollaborate"));
const EcomErp = lazy(() => import("./EcomErp"));
const EcomRooms = lazy(() => import("./EcomRooms"));
const EcomConsult = lazy(() => import("./EcomConsult"));
const EcomSystem = lazy(() => import("./EcomSystem"));
const EcomTech = lazy(() => import("./EcomTech"));
const EcomEnd = lazy(() => import("./EcomEnd"));
const HealthIndustries = lazy(() => import("../healthcare/HealthIndustries"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const EcomClient = lazy(() => import("./EcomClient"));
const EcomCase = lazy(() => import("./EcomCase"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. Why is Mobility Infotech the right choice for e-commerce software development?",
    answer: "Mobility Infotech stands out with innovative solutions, scalable technology, and a client-centric approach. We offer tailored e-commerce platforms integrated with secure payment gateways, ERP systems, CRM tools, and inventory management.",
  },
  {
    id: "1",
    question: "02. What SEO strategies do you implement when building an e-commerce store?",
    answer: "We follow industry-proven SEO best practices, including optimized content, fast-loading pages, mobile-friendly design, structured metadata, and search engine indexing to drive traffic and conversions.",
  },
  {
    id: "2",
    question: "03. What development approaches or frameworks do you use?",
    answer: "We employ agile methodologies, ensuring iterative development and flexibility. Our team specializes in frameworks like React, Angular, Node.js, Magento, Shopify, and headless architecture.",
  },
  {
    id: "3",
    question: "04. Will the e-commerce solution scale as my business grows?",
    answer: "Yes, we create scalable platforms that grow with your business, supporting high-traffic volumes, product expansions, and advanced integrations.",
  },
  {
    id: "4",
    question: "05. What is the estimated cost of developing an e-commerce store?",
    answer: "Costs vary based on project complexity, features, and customization. We offer cost-effective solutions with transparent pricing to fit your budget.",
  },
  {
    id: "5",
    question: "06. How do you manage the design and development phases?",
    answer: "Our process includes requirement analysis, user-friendly design, agile development, rigorous testing, and deployment, ensuring a seamless experience from start to finish.",
  },
  {
    id: "6",
    question:
      "07. Which emerging technologies do you incorporate in e-commerce development?",
    answer: "We leverage technologies like AI for personalization, PWA for enhanced performance, AR/VR for immersive experiences, and blockchain for secure transactions.",
  },
  {
    id: "7",
    question: "08. Do you design e-commerce websites using templates or offer custom solutions?",
    answer: "We provide both options. Clients can choose pre-made themes for quicker deployment or opt for fully customized designs tailored to their business needs.",
  },
];
export default function Ecommerce() {
  return (
    <>
      <EcomBanner />
      <EcomRetail />

      <Suspense fallback={null}>
        <EcommerceBuild />
        <EcomCollaborate />
        <EcomPlatfrom />
        <EcomSystem />
        <EcomErp />
        <EcomTech />
        <EcomRooms />
        <EcomEnd />
        <EcomConsult />
        <HealthIndustries />
        <EcomClient />
        <ShuttleAppreciation />
        <EcomCase />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
